import defaultTheme from "./default";

const palette = { ...defaultTheme.palette };
palette.primary = "hsla(19, 72%, 51%,1)";

const theme = { ...defaultTheme, palette };

export default theme;
